import PropTypes from 'prop-types';
import { Fragment, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'react-utils/debounce';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { getFormData, getHar, getIsMultipart, getOas, getOperation, getAvailableClientLibraries
// @ts-expect-error No types given for file
} from '../../../modules/Doc/selectors/DocSelectors';
//from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';

// @ts-expect-error No types given for file
import Markdown from '../../../modules/Doc/components/Markdown';
import ClickableHeader from '../../../modules/Header/ClickableHeader';

// @ts-expect-error No types given for file
import ErrorBoundary from '../../../modules/ErrorBoundary/ErrorBoundary';

// @ts-expect-error No types given for file
import { updateFormData } from '../../../modules/Doc/actions';

// @ts-expect-error No types given for file
import removeUndefinedObjects from '../../../lib/api-explorer/remove-undefined-objects';
import { OasPropType, OperationPropType } from '../../../lib/api-explorer/models/Oas';

// @ts-expect-error No types given for file
import { getRequestBodyExample } from '../../../modules/Doc/utils/ExampleUtils';
import NewParams from './NewParams';
import H4 from 'UIComponents/elements/headings/H4';
import NewRequirements from '../../../modules/Doc/components/NewRequirements';
import Response from '../../Response/components/Response';
import PathUrl from '../../../modules/Doc/components/PathUrl';
// @ts-expect-error No types given for file
import CodeSample from '../../../modules/CodeSample/components/CodeSample';
import CardComp from '../../../components/endpoint/CardComp';
import LeftColumnComp from '../../../components/endpoint/LeftColumnComp';
import RightColumnComp from '../../../components/endpoint/RightColumnComp';
import Excerpt from '../../../components/endpoint/Excerpt';
import { stringToId } from '../../../utils/urls';
import { useScrollHashIntoView } from '../../../hooks/useScrollHashIntoView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledRequirementsPanel = styled.div.withConfig({
  displayName: "NewDoc__StyledRequirementsPanel",
  componentId: "c31xf4-0"
})(["border:2px solid ", ";border-radius:10px;margin-bottom:24px;padding:26px 16px;"], GREAT_WHITE);
const PathContainer = styled.div.withConfig({
  displayName: "NewDoc__PathContainer",
  componentId: "c31xf4-1"
})(["margin-bottom:38px;"]);
const Header = ({
  doc,
  oas,
  oasDocs,
  operation,
  isMultipart,
  isDirty
}) => {
  const renderPathUrl = () => {
    return /*#__PURE__*/_jsx(PathUrl, {
      doc: doc,
      dirty: isDirty,
      oas: oas,
      oasDocs: oasDocs,
      operation: operation,
      isMultipart: isMultipart,
      newLayout: true
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (doc.title || doc.excerpt) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [doc.title && /*#__PURE__*/_jsx(ClickableHeader, {
        Component: H4,
        id: stringToId(`${doc.api.method}-${doc.swagger.path}`),
        className: "m-bottom-8",
        children: doc.title
      }), doc.type === 'endpoint' && /*#__PURE__*/_jsx(PathContainer, {
        children: renderPathUrl()
      }), doc.excerpt && /*#__PURE__*/_jsx(Excerpt, {
        children: /*#__PURE__*/_jsx(Markdown, {
          children: doc.excerpt
        })
      })]
    })
  });
};
function Doc(props) {
  const populateFormDataWithExample = () => {
    const {
      operation,
      oas,
      formData
    } = props;
    if (operation.requestBody && !removeUndefinedObjects(formData.body)) {
      const exampleRequestBody = getRequestBodyExample(operation, oas, false, true);
      if (exampleRequestBody) {
        try {
          formData.body = JSON.parse(exampleRequestBody.code);
        } catch (__) {
          // some examples aren't JSON parseable (i.e. "string") so just display the code
          formData.body = exampleRequestBody.code;
        }
      }
    }
    return formData;
  };
  const [state, setState] = useState({
    dirty: false,
    formData: populateFormDataWithExample(),
    initialFormData: populateFormDataWithExample(),
    hasError: false
  });
  const debouncedUpdateFormData = debounce(props.updateFormData, 200);
  useScrollHashIntoView(props.headerId);
  const resetFormState = () => {
    setState({
      hasError: false
    });
  };
  const onFormDataChange = formData => {
    setState(prevState => {
      return {
        formData: Object.assign({}, prevState.formData, formData),
        dirty: true
      };
    });
    debouncedUpdateFormData(formData, props.doc._id);
  };
  const registerError = () => {
    const {
      initialFormData
    } = state;
    /*
      This is placed here in order to prevent a race condition from occurring.
      When placed in `resetFormState`, the form will only reset after hitting
      the button to acknowledge the error occurred in the boundary component
      twice. Moving it here removed this condition.
    */
    onFormDataChange(initialFormData);
    setState({
      hasError: true
    });
  };
  const renderCodeSample = () => {
    const {
      hasError
    } = state;
    const {
      doc,
      har,
      isMultipart,
      language,
      oas,
      oasDocs,
      operation,
      setLanguage,
      availableClientLibraries
    } = props;
    let examples;
    try {
      examples = doc.api.examples.codes;
    } catch (e) {
      examples = [];
    }
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      hasError: hasError,
      resetFormState: resetFormState,
      registerError: registerError,
      children: /*#__PURE__*/_jsx(CodeSample, {
        doc: doc,
        har: har,
        isMultipart: isMultipart,
        oas: oas,
        oasDocs: oasDocs,
        setLanguage: setLanguage,
        operation: operation,
        formData: state.formData,
        language: language,
        examples: examples,
        availableClientLibraries: availableClientLibraries,
        newLayout: true
      })
    });
  };
  const renderResponse = () => {
    const {
      doc,
      oas,
      operation
    } = props;
    let exampleResponses;
    try {
      exampleResponses = props.doc.api.results.codes;
    } catch (e) {
      exampleResponses = [];
    }
    return /*#__PURE__*/_jsx(Response, {
      docId: doc._id,
      newLayout: true,
      oas: oas,
      operation: operation,
      exampleResponses: exampleResponses
    });
  };
  const renderParams = () => {
    const {
      oas,
      operation
    } = props;
    return /*#__PURE__*/_jsx(NewParams, {
      formData: state.formData,
      oas: oas,
      onChange: onFormDataChange,
      operation: operation
    });
  };
  const {
    hasError
  } = state;
  const {
    doc,
    operation
  } = props;
  const columnSpan = useMemo(() => ({
    base: 12,
    laptop: 6
  }), []);
  return /*#__PURE__*/_jsxs(CardComp, {
    testId: `doc-${doc.api.method}-${doc.swagger.path}`,
    children: [/*#__PURE__*/_jsxs(LeftColumnComp, {
      columnSpan: columnSpan,
      children: [/*#__PURE__*/_jsx(Header, {
        doc: doc,
        isDirty: state.dirty,
        isMultipart: props.isMultipart,
        oas: props.oas,
        oasDocs: props.oasDocs,
        operation: props.operation
      }), /*#__PURE__*/_jsx(StyledRequirementsPanel, {
        children: /*#__PURE__*/_jsx(NewRequirements, {
          newLayout: true,
          doc: doc,
          operation: operation
        })
      }), doc.type === 'endpoint' && !hasError && renderParams(), doc.body && /*#__PURE__*/_jsx("span", {
        children: "DocBody"
      })]
    }), /*#__PURE__*/_jsxs(RightColumnComp, {
      columnSpan: columnSpan,
      children: [doc.type === 'endpoint' && /*#__PURE__*/_jsxs(Fragment, {
        children: [renderCodeSample(), renderResponse()]
      }), doc.body && /*#__PURE__*/_jsx("span", {
        children: "DocBody"
      })]
    })]
  });
}
Doc.propTypes = {
  doc: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string,
    slug: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    body: PropTypes.string,
    api: PropTypes.shape({
      method: PropTypes.string.isRequired,
      params: PropTypes.object,
      examples: PropTypes.shape({
        codes: PropTypes.arrayOf(PropTypes.shape({
          language: PropTypes.string.isRequired,
          code: PropTypes.string.isRequired
        }))
      }),
      results: PropTypes.shape({
        codes: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }),
    swagger: PropTypes.shape({
      path: PropTypes.string.isRequired
    })
  }).isRequired,
  flags: PropTypes.shape({
    correctnewlines: PropTypes.bool
  }).isRequired,
  formData: PropTypes.object.isRequired,
  har: PropTypes.shape({}).isRequired,
  isMultipart: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  oas: OasPropType.isRequired,
  oasDocs: PropTypes.array.isRequired,
  operation: OperationPropType.isRequired,
  setLanguage: PropTypes.func.isRequired,
  updateFormData: PropTypes.func.isRequired,
  availableClientLibraries: PropTypes.array.isRequired
};
Doc.defaultProps = {
  oas: {},
  flags: {
    correctnewlines: false
  }
};
const mapStateToProps = (state, ownProps) => {
  return {
    formData: getFormData(state, ownProps),
    har: getHar(state, ownProps),
    isMultipart: getIsMultipart(state, ownProps),
    oas: getOas(state),
    operation: getOperation(state, ownProps),
    availableClientLibraries: getAvailableClientLibraries(state)
  };
};
const mapDispatchToProps = {
  updateFormData
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Doc));